import script from "./ManageCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageCustomer.vue?vue&type=script&setup=true&lang=js"

import "./ManageCustomer.vue?vue&type=style&index=0&id=54033b9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54033b9a"]])

export default __exports__